module.exports = __webpack_public_path__ + "static/media/mysql-logo.53c43022.png";